import { render, staticRenderFns } from "./set-batch.vue?vue&type=template&id=c19d1a16&scoped=true"
import script from "./set-batch.vue?vue&type=script&lang=js"
export * from "./set-batch.vue?vue&type=script&lang=js"
import style0 from "./set-batch.vue?vue&type=style&index=0&id=c19d1a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19d1a16",
  null
  
)

export default component.exports